"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaQuery = void 0;
var MediaQuery;
(function (MediaQuery) {
    MediaQuery[MediaQuery["SMALL"] = 768] = "SMALL";
    MediaQuery[MediaQuery["MEDIUM"] = 1024] = "MEDIUM";
})(MediaQuery || (exports.MediaQuery = MediaQuery = {}));
